import { useState, useEffect } from "react";
import axios from "axios";

export interface ICompanyData {
    status: 'LogDisabled' | 'NotFound' | 'Success',
    id: number,
    address: string,
    city: string,
    contacts: IContactData[],
    email: string,
    name: string,
    nip: string,
    phone: string,
    regon: string,
    zipCode: string,
}

export interface IContactData{
    id: number,
    communicator: string,
    email: string,
    firstName: string,
    phone: string,
    position: string,
    surname: string,
}

type GetCompanyApi = () => [
    (userId: string) => void,
    ICompanyData,
    boolean,
    boolean
];

export const useGetCompanyApi: GetCompanyApi = () => {
    const [name, setName] = useState<string>(null);
    const [data, setData] = useState<ICompanyData>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            try {
                const result = await axios('/LogDictionaries/Company/?name=' + encodeURIComponent(name));
                setData(result.data);
            } catch (error) {
                console.error(error);
                setIsError(true);
            }
            setIsLoading(false);
        };

        if (!name)
            return;

        fetchData();
    }, [name]);
    return [setName, data, isLoading, isError];
}
